var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"logo"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.config.platformName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }